import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import Em from 'ember';
export default Em.Mixin.create({
  setupEditorDimensions() {
    if (Em.isPresent($(this.element))) {
      let width = $(this.element).outerWidth();
      let height = $(this.element).outerHeight();
      let arrowHeight = this.get('arrowHeight');
      this.setProperties({
        width,
        height,
        horizontalPositionOffset: width / 2,
        verticalPositionOffset: arrowHeight
      });
    }
  },
  style: Em.computed('selectionCoordinates.{top,left}', 'width', 'height', 'hasPositionOffset', function () {
    let selectionCoordinates = this.get('selectionCoordinates');
    let style = '';
    if (selectionCoordinates && this.get('isWithinViewport')) {
      let selectionCenter = selectionCoordinates.left + selectionCoordinates.width / 2;
      let left = selectionCenter - this.get('width') / 2;
      if (this.get('hasPositionOffset')) {
        let horizontalOffset = this._horizontalOffsetForOverflowParent(left);
        left += horizontalOffset;
        this.positionPointer(horizontalOffset);
      }
      let top = selectionCoordinates.top - (this.get('height') + this.get('verticalPositionOffset'));
      style = `top:${Math.round(top)}px;left:${Math.round(left)}px`;
    }
    return sanitizeHtml(style);
  }),
  positionPointer(offset) {
    $('style', this.element).remove();
    if (offset) {
      let style = `#${this.get('elementId')}:before, #${this.get('elementId')}:after { left: calc(50% - ${offset}px); }`;
      // eslint-disable-next-line jquery-unsafe/no-appendTo
      $(`<style>${style}</style>`).appendTo($(this.element));
    }
  },
  _horizontalOffsetForOverflowParent(horizontalPosition) {
    let leftEdge, rightEdge;
    let formatterWidth = $(this.element).outerWidth();
    leftEdge = horizontalPosition;
    rightEdge = horizontalPosition + formatterWidth;
    let overflowBounds = this._findOverflowParentPosition();
    let parentBounds = $(this.element).parent()[0].getBoundingClientRect();
    let parentWidth = parentBounds.width;
    let leftBleed = overflowBounds.left - parentBounds.left;
    let rightBleed = overflowBounds.right - parentBounds.right;
    if (leftEdge < 0) {
      if (leftEdge < leftBleed) {
        return Math.abs(leftEdge) - Math.abs(leftBleed);
      }
    }
    if (rightEdge > parentBounds.width) {
      if (rightEdge > parentWidth + rightBleed) {
        return parentWidth + rightBleed - rightEdge;
      }
    }
    return 0;
  },
  _findOverflowParentPosition() {
    let overflowParent = $(this.element).parents().filter(function () {
      return $(this).css('overflow') !== 'visible';
    }).first();
    if (overflowParent.length === 0) {
      return document.body.getBoundingClientRect();
    }
    return overflowParent[0].getBoundingClientRect();
  }
});